/**
 * Class representing image meta data
 */
export class ImageMeta {
  /**
   * Create an image.
   * @param {String} options.caption - what is displayed in the picture
   * @param {String} options.imageUrl - the url of the image
   */
  constructor (options) {
    if (options) {
      this.caption = options.caption
      this.imageUrl = options.imageUrl
    }
  }

  get caption () {
    return this._caption
  }

  set caption (value) {
    if (value) this._caption = String(value)
    else this._caption = null
  }

  get imageUrl () {
    return this._imageUrl
  }

  set imageUrl (value) {
    if (value) this._imageUrl = String(value)
    else this._imageUrl = null
  }

  toJSON () {
    return {
      caption: this._caption,
      imageUrl: this._imageUrl
    }
  }
}
